import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import './PagoPublico.css';

const API    = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';
const WA_NUM = '51940686868';

/* ── Icons ── */
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCopy     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClock    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBox      = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>);
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconImage    = () => (<svg viewBox="0 0 24 24" fill="none" width="32" height="32"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/><polyline points="21 15 16 10 5 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="16" height="16"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconUser     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/></svg>);

const parseDatosPago = (val) => {
  if (!val) return {};
  if (typeof val === 'object') return val;
  try { return JSON.parse(val); } catch(e) { return {}; }
};

export default function PagoPublico() {
  const { token }        = useParams();
  const navigate          = useNavigate();
  const fileRef          = useRef();
  const { estaLogueado, usuario } = useAuthUser();

  /* ── Estado principal ── */
  const [link,     setLink]     = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const [copied,   setCopied]   = useState(false);
  const [expiraEn, setExpiraEn] = useState('');

  /* ── Estado puntos ── */
  const [puntosUsuario, setPuntosUsuario] = useState(null);
  const [usarPuntos,    setUsarPuntos]    = useState(false);
  const [puntosAplicar, setPuntosAplicar] = useState(0);

  /* ── Estado formulario envío voucher ── */
  const [numOp,        setNumOp]        = useState('');
  const [numOpError,   setNumOpError]   = useState('');
  const [numOpOk,      setNumOpOk]      = useState(false);
  const [validandoNum, setValidandoNum] = useState(false);
  const [voucher,      setVoucher]      = useState(null);
  const [voucherPrev,  setVoucherPrev]  = useState(null);
  const [enviando,     setEnviando]     = useState(false);
  const [enviadoOk,    setEnviadoOk]    = useState(false);
  const [envError,     setEnvError]     = useState('');

  /* ── Estado método de pago ── */
  const [metodoPago, setMetodoPago] = useState(null); // 'tarjeta' | 'transferencia'

  /* ── Estado Culqi ── */
  const [culqiListo, setCulqiListo] = useState(false);
  const [pagando,    setPagando]    = useState(false);
  const [pagoError,  setPagoError]  = useState('');
  const [guestNombre, setGuestNombre] = useState('');
  const [guestEmail,  setGuestEmail]  = useState('');

  /* ── Cálculo puntos ── */
  const puntosDisponibles = puntosUsuario?.puntos_disponibles || 0;
  const puntosMaxUsar     = Math.min(
    puntosDisponibles,
    Math.floor(parseFloat(link?.monto || 0) * 0.30 * 100)
  );
  const descuentoPuntos   = usarPuntos ? parseFloat((puntosAplicar / 100).toFixed(2)) : 0;
  const montoFinal        = Math.max(0, parseFloat((parseFloat(link?.monto || 0) - descuentoPuntos).toFixed(2)));

  /* ── Fetch link ── */
  useEffect(() => {
    fetch(`${API}?action=link_pago&token=${token}`)
      .then(r => r.json())
      .then(j => {
        if (j.success) setLink(j.data);
        else setError(j.message || 'Link no encontrado o expirado');
      })
      .catch(() => setError('Error al cargar el link de pago'))
      .finally(() => setLoading(false));
  }, [token]);

  /* ── Precargar datos del cliente al cargar el link ── */
  useEffect(() => {
    if (link) {
      setGuestNombre(link.nombre_cliente || '');
      setGuestEmail(link.email_cliente || '');
    }
  }, [link]);

  /* ── Cargar puntos si está logueado ── */
  useEffect(() => {
    if (!estaLogueado) return;
    const tkn = localStorage.getItem('com_token');
    if (!tkn) return;
    fetch(`${API}?action=mis_puntos`, {
      headers: { 'Authorization': `Bearer ${tkn}` }
    })
      .then(r => r.json())
      .then(j => { if (j.success) setPuntosUsuario(j.data); })
      .catch(() => {});
  }, [estaLogueado]);

  /* ── Cargar script de Culqi ── */
  useEffect(() => {
    if (document.getElementById('culqi-script')) { setCulqiListo(true); return; }
    const script = document.createElement('script');
    script.id  = 'culqi-script';
    script.src = 'https://checkout.culqi.com/js/v4';
    script.onload = () => setCulqiListo(true);
    document.body.appendChild(script);
  }, []);

  /* ── Contador regresivo ── */
  useEffect(() => {
    if (!link?.expira_at) return;
    const calcular = () => {
      const diff = new Date(link.expira_at) - new Date();
      if (diff <= 0) { setExpiraEn('Expirado'); return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      setExpiraEn(`${h}h ${m}m restantes`);
    };
    calcular();
    const iv = setInterval(calcular, 60000);
    return () => clearInterval(iv);
  }, [link]);

  /* ── Copiar ── */
  const copiarCuenta = (texto) => {
    navigator.clipboard.writeText(texto);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  /* ── Voucher ── */
  const handleVoucherChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowed = ['image/jpeg','image/png','image/webp','image/gif','application/pdf'];
    if (!allowed.includes(file.type)) { setEnvError('Solo se permiten imágenes (JPG, PNG, WEBP) o PDF'); return; }
    if (file.size > 10 * 1024 * 1024) { setEnvError('El archivo no debe superar 10 MB'); return; }
    setVoucher(file);
    setEnvError('');
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = ev => setVoucherPrev(ev.target.result);
      reader.readAsDataURL(file);
    } else {
      setVoucherPrev('pdf');
    }
  };

  const quitarVoucher = () => {
    setVoucher(null); setVoucherPrev(null);
    if (fileRef.current) fileRef.current.value = '';
  };

  /* ── Validar N° operación ── */
  const validarNumOp = async (val) => {
    const clean = val.trim();
    if (!clean) { setNumOpError(''); setNumOpOk(false); return; }
    if (clean.length < 4) { setNumOpError('Mínimo 4 caracteres'); setNumOpOk(false); return; }
    setValidandoNum(true); setNumOpError(''); setNumOpOk(false);
    try {
      const r = await fetch(`${API}?action=validar_referencia&referencia=${encodeURIComponent(clean)}`);
      const j = await r.json();
      if (j.success && j.data?.duplicado) {
        setNumOpError('Este número de operación ya fue registrado anteriormente');
        setNumOpOk(false);
      } else { setNumOpOk(true); }
    } catch { setNumOpOk(true); }
    finally { setValidandoNum(false); }
  };

  /* ── Pagar con Culqi (tarjeta) ── */
  const pagarConCulqi = () => {
    const nombreFinal = estaLogueado
      ? [usuario?.nombre, usuario?.apellido].filter(Boolean).join(' ')
      : guestNombre.trim();
    const emailFinal = estaLogueado ? usuario?.email : guestEmail.trim();

    setPagoError('');
    if (!nombreFinal) { setPagoError('Ingresa tu nombre'); return; }
    if (!emailFinal || !emailFinal.includes('@')) { setPagoError('Ingresa un correo válido'); return; }
    if (!culqiListo || !window.Culqi) { setPagoError('Culqi no está listo, recarga la página'); return; }

    window.Culqi.publicKey = 'pk_live_q8uWthWANueTtfxM';
    window.Culqi.settings({
      title:       'Comunicar',
      currency:    'PEN',
      description: (link.recurso_titulo || '').slice(0, 80),
      amount:      Math.round(montoFinal * 100),
    });
    window.Culqi.options({ lang: 'es', installments: false });

    window.culqi = async () => {
      if (window.Culqi.token) {
        const culqiToken = window.Culqi.token.id;
        window.Culqi.close();
        setPagando(true);
        setPagoError('');
        try {
          const tkn = localStorage.getItem('com_token');
          const headers = { 'Content-Type': 'application/json' };
          if (tkn) headers['Authorization'] = `Bearer ${tkn}`;

          // 1. Crear pedido a partir del link de pago
          const rPed = await fetch(`${API}?action=crear_pedido_link`, {
            method: 'POST', headers,
            body: JSON.stringify({
              token,
              nombre:           nombreFinal,
              email:            emailFinal.toLowerCase().trim(),
              telefono:         usuario?.whatsapp || usuario?.telefono || '',
              monto_final:      montoFinal,
              puntos_usados:    usarPuntos ? puntosAplicar : 0,
              descuento_puntos: usarPuntos ? descuentoPuntos : 0,
            }),
          });
          const jPed = await rPed.json();
          if (!jPed.success) throw new Error(jPed.message);

          // 2. Cobrar con Culqi
          const rCharge = await fetch(
            'https://centrocomunicar.com/api-comunicar/endpoints/culqi_charge.php?action=crear_cargo',
            {
              method: 'POST', headers,
              body: JSON.stringify({
                culqi_token:       culqiToken,
                pedido_carrito_id: jPed.data.pedido_id,
                monto:             montoFinal,
                email:             emailFinal.toLowerCase().trim(),
                nombre:            nombreFinal,
              }),
            }
          );
          const jCharge = await rCharge.json();
          if (!jCharge.success) throw new Error(jCharge.message);

          navigate('/pago-exitoso?metodo=culqi&pedido=' + jPed.data.codigo);
        } catch (err) {
          setPagoError(err.message);
        } finally {
          setPagando(false);
        }
      } else if (window.Culqi.error) {
        setPagoError(window.Culqi.error.user_message || 'Error en el pago');
      }
    };

    window.Culqi.open();
  };

  /* ── Enviar voucher (transferencia) ── */
  const handleEnviar = async () => {
    setEnvError('');
    if (!voucher) { setEnvError('Adjunta el comprobante de pago para continuar'); return; }
    if (numOp.trim() && numOp.trim().length < 4) { setEnvError('El N° de operación debe tener al menos 4 caracteres'); return; }

    if (numOp.trim()) {
      try {
        const r = await fetch(`${API}?action=validar_referencia&referencia=${encodeURIComponent(numOp.trim())}`);
        const j = await r.json();
        if (j.success && j.data?.duplicado) {
          setEnvError('El N° de operación ' + numOp.trim() + ' ya fue registrado. Verifica el número.');
          setNumOpError('Este número ya fue registrado');
          setNumOpOk(false);
          return;
        }
      } catch {}
    }

    if (numOpError) { setEnvError(numOpError); return; }
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append('archivo', voucher);
      fd.append('token', token);
      if (numOp.trim()) fd.append('referencia_pago', numOp.trim());
      if (usarPuntos && puntosAplicar > 0) {
        fd.append('puntos_usados',    puntosAplicar);
        fd.append('descuento_puntos', descuentoPuntos);
        fd.append('monto_final',      montoFinal);
      }

      const headers = {};
      const comToken = localStorage.getItem('com_token');
      if (comToken) headers['Authorization'] = `Bearer ${comToken}`;

      const r = await fetch(`${API}?action=enviar_voucher`, {
        method: 'POST',
        headers,
        body: fd
      });

      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setEnviadoOk(true);
    } catch(err) {
      setEnvError(err.message || 'Error al enviar. Intenta de nuevo.');
    } finally { setEnviando(false); }
  };

  /* ── WhatsApp alternativo ── */
  const abrirWhatsApp = () => {
    if (!link) return;
    const ref = numOp.trim() ? `\n🔢 N° operación: *${numOp.trim()}*` : '';
    const msg = `Hola, acabo de realizar el pago por:\n📦 *${link.recurso_titulo}*\n💰 S/. ${parseFloat(link.monto).toFixed(2)}${ref}\n\nAdjunto mi comprobante de pago.`;
    window.open(`https://wa.me/${WA_NUM}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  /* ── Renders de estado ── */
  if (loading) return (
    <div className="pp-splash">
      <div className="pp-splash__spinner"/>
      <p>Cargando datos de pago…</p>
    </div>
  );

  if (error) return (
    <div className="pp-splash pp-splash--error">
      <div className="pp-splash__icon">⚠️</div>
      <h2>Link no disponible</h2>
      <p>{error}</p>
      <Link to="/" className="pp-btn-home">Volver al inicio</Link>
    </div>
  );

  /* ── Pantalla éxito (voucher enviado) ── */
  if (enviadoOk) return (
    <div className="pp-page">
      <nav className="pp-nav">
        <Link to="/" className="pp-nav__logo">
          <img src="/images/logo_centro.png" alt="Comunicar" style={{height:36,width:'auto',display:'block'}}/>
        </Link>
        <a href="https://centrocomunicar.com" className="pp-nav__link">Ir al inicio</a>
      </nav>

      <div className="pp-exito">
        <div className="pp-exito__icon">
          <svg viewBox="0 0 24 24" fill="none" width="44" height="44">
            <circle cx="12" cy="12" r="10" fill="#d4f4e8"/>
            <path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2>¡Comprobante enviado!</h2>
        <p>Recibimos tu voucher. En breve validaremos tu pago y activaremos tu acceso.</p>

        {!estaLogueado && (
          <div style={{
            width:'100%', background:'#fff8ed', border:'1.5px solid #fcd34d',
            borderRadius:16, padding:'1.2rem 1.4rem', textAlign:'left',
            display:'flex', flexDirection:'column', gap:'.8rem'
          }}>
            <div style={{display:'flex',alignItems:'center',gap:'.6rem'}}>
              <span style={{fontSize:'1.4rem'}}>🎓</span>
              <div>
                <strong style={{display:'block',fontSize:'.95rem',color:'#111614'}}>
                  Próximo paso: crea tu cuenta
                </strong>
                <span style={{fontSize:'.82rem',color:'#92400e'}}>
                  Necesitas una cuenta para inscribirte al curso y acceder a tus materiales
                </span>
              </div>
            </div>
            <p style={{fontSize:'.82rem',color:'#78350f',lineHeight:1.6,margin:0}}>
              Una vez que validemos tu pago, recibirás un email con el link de inscripción.
              Crea tu cuenta ahora para tenerla lista.
            </p>
            <div style={{display:'flex',gap:'.6rem',flexWrap:'wrap'}}>
              <Link to="/registro" style={{
                flex:1, background:'#111614', color:'#82D8B3', border:'none',
                borderRadius:100, padding:'.75rem 1rem', fontFamily:'inherit',
                fontWeight:700, fontSize:'.85rem', cursor:'pointer', textAlign:'center',
                textDecoration:'none', display:'flex', alignItems:'center',
                justifyContent:'center', gap:'.4rem'
              }}>
                ✨ Crear cuenta gratis
              </Link>
              <Link to={`/login?redirect=/pago/${token}`} style={{
                flex:1, background:'#edfaf4', color:'#0f3525',
                border:'1.5px solid rgba(130,216,179,.4)', borderRadius:100,
                padding:'.75rem 1rem', fontFamily:'inherit', fontWeight:700,
                fontSize:'.85rem', cursor:'pointer', textAlign:'center',
                textDecoration:'none', display:'flex', alignItems:'center',
                justifyContent:'center', gap:'.4rem'
              }}>
                Iniciar sesión
              </Link>
            </div>
          </div>
        )}

        {estaLogueado && (
          <div style={{
            width:'100%', background:'#edfaf4', border:'1.5px solid #d4f4e8',
            borderRadius:16, padding:'1.2rem 1.4rem', textAlign:'left'
          }}>
            <div style={{display:'flex',alignItems:'center',gap:'.6rem',marginBottom:'.5rem'}}>
              <span style={{fontSize:'1.2rem'}}>✅</span>
              <strong style={{fontSize:'.95rem',color:'#111614'}}>
                ¡Perfecto! Estás logueado como {usuario?.nombre}
              </strong>
            </div>
            <p style={{fontSize:'.82rem',color:'#065f46',lineHeight:1.6,margin:0}}>
              Una vez validado el pago, recibirás un email con el link de inscripción al curso.
              También podrás verlo en <strong>Mi Cuenta → Mis recursos</strong>.
            </p>
          </div>
        )}

        {usarPuntos && puntosAplicar > 0 && (
          <p className="pp-exito__puntos">
            🎉 Se aplicó un descuento de <strong>S/. {descuentoPuntos.toFixed(2)}</strong> con tus puntos.
          </p>
        )}
        <p className="pp-exito__sub">Recibirás una notificación cuando tu pago sea confirmado.</p>
        <div className="pp-exito__btns">
          <button className="pp-btn-wa pp-btn-wa--sm" onClick={abrirWhatsApp}>
            <IconWhatsapp/> Confirmar también por WhatsApp
          </button>
          {!estaLogueado && (
            <Link to={`/login?redirect=/pago/${token}`} className="pp-exito__login-btn">
              <IconUser/> Inicia sesión para ver tus puntos acumulados
            </Link>
          )}
          {estaLogueado && (
            <Link to="/mi-cuenta" className="pp-exito__cuenta-btn">
              Ver mis puntos en Mi Cuenta <IconArrow/>
            </Link>
          )}
          <Link to="/" className="pp-btn-home">Volver al inicio</Link>
        </div>
      </div>
      <footer className="pp-footer">
        <p>© 2026 Comunicar – Desarrollo y Lenguaje</p>
        <Link to="/">Inicio</Link>
      </footer>
    </div>
  );

  const dp = parseDatosPago(link.datos_pago);
  const tieneTransferencia = !!(dp.banco || dp.nombre_cuenta);

  return (
    <div className="pp-page">

      {/* ── NAV ── */}
      <nav className="pp-nav">
        <Link to="/" className="pp-nav__logo">
          <img src="/images/logo_centro.png" alt="Comunicar" style={{height:36,width:'auto',display:'block'}}/>
        </Link>
        <div className="pp-nav__right">
          {estaLogueado ? (
            <span className="pp-nav__usuario">
              <IconUser/> {usuario?.nombre}
            </span>
          ) : (
            <Link to={`/login?redirect=/pago/${token}`} className="pp-nav__link pp-nav__link--login">
              Iniciar sesión
            </Link>
          )}
          <a href="https://centrocomunicar.com" className="pp-nav__link">
            Ir al inicio
          </a>
        </div>
      </nav>

      <div className="pp-inner">

        {/* ══════════════════════════════
            COLUMNA IZQUIERDA
        ══════════════════════════════ */}
        <div className="pp-left">

          {estaLogueado ? (
            <div className="pp-saludo pp-saludo--logueado">
              <IconUser/>
              <div>
                <strong>Hola, {usuario?.nombre} 👋</strong>
                <span>Estás logueado — tus puntos se acumularán automáticamente</span>
              </div>
            </div>
          ) : link.nombre_cliente ? (
            <div className="pp-saludo">
              Hola, <strong>{link.nombre_cliente}</strong> 👋
            </div>
          ) : null}

          <div className="pp-recurso-card">
            <div className="pp-recurso-card__icon"><IconBox/></div>
            <div className="pp-recurso-card__info">
              <span className="pp-recurso-card__label">Recurso a adquirir</span>
              <h2>{link.recurso_titulo}</h2>
              {link.recurso_desc && <p>{link.recurso_desc}</p>}
              {link.descripcion && (
                <div className="pp-recurso-card__nota">
                  <strong>Nota:</strong> {link.descripcion}
                </div>
              )}
            </div>
          </div>

          <div className="pp-precio-box">
            <div>
              <span className="pp-precio-label">Total a pagar</span>
              <div className="pp-precio-valor-wrap">
                <span className="pp-precio-valor">
                  S/. {montoFinal.toFixed(2)}
                </span>
                {usarPuntos && descuentoPuntos > 0 && (
                  <s className="pp-precio-original">
                    S/. {parseFloat(link.monto).toFixed(2)}
                  </s>
                )}
              </div>
              {usarPuntos && descuentoPuntos > 0 && (
                <span className="pp-precio-ahorro">
                  Ahorraste S/. {descuentoPuntos.toFixed(2)} con puntos 🎉
                </span>
              )}
            </div>
            <div className="pp-precio-metodo">
              <IconShield/>
              <span>Pago seguro</span>
            </div>
          </div>

          {expiraEn && (
            <div className={`pp-expira ${expiraEn==='Expirado'?'pp-expira--red':''}`}>
              <IconClock/> {expiraEn==='Expirado' ? 'Este link ha expirado' : `Válido por: ${expiraEn}`}
            </div>
          )}

          <div className="pp-incluye">
            <p className="pp-incluye__label">Al completar el pago recibirás:</p>
            <div className="pp-incluye__items">
              <div><IconCheck/>Acceso activado en tu cuenta</div>
              <div><IconCheck/>Descarga inmediata del material</div>
              <div><IconCheck/>Disponible de por vida en /mi-cuenta</div>
              <div><IconCheck/>Soporte por WhatsApp</div>
              {estaLogueado && (
                <div><IconCheck/><strong>+{Math.round(montoFinal * 10).toLocaleString()} puntos</strong> por esta compra</div>
              )}
            </div>
          </div>

        </div>

        {/* ══════════════════════════════
            COLUMNA DERECHA
        ══════════════════════════════ */}
        <div className="pp-right">
          <div className="pp-panel">

            <div className="pp-panel__head">
              <span className="pp-panel__emoji">💳</span>
              <div>
                <h3>Completa tu pago</h3>
                <p>Elige cómo deseas pagar</p>
              </div>
            </div>

            {/* ══ SECCIÓN PUNTOS ══ */}
            <div className="pp-puntos-zona">
              {estaLogueado && puntosDisponibles >= 500 && (
                <div className="pp-puntos-canje">
                  <div className="pp-puntos-canje__head">
                    <div className="pp-puntos-canje__info">
                      <IconStar/>
                      <div>
                        <strong>Tienes {puntosDisponibles.toLocaleString()} puntos</strong>
                        <span>= S/. {(puntosDisponibles/100).toFixed(2)} de descuento máximo</span>
                      </div>
                    </div>
                    <label className="pp-puntos-toggle">
                      <input
                        type="checkbox"
                        checked={usarPuntos}
                        onChange={e => {
                          setUsarPuntos(e.target.checked);
                          setPuntosAplicar(e.target.checked ? puntosMaxUsar : 0);
                        }}
                      />
                      <span className="pp-puntos-toggle__slider"/>
                    </label>
                  </div>
                  {usarPuntos && (
                    <div className="pp-puntos-canje__detalle">
                      <label>
                        Puntos a usar: <strong>{puntosAplicar.toLocaleString()}</strong>
                        <span> = S/. {(puntosAplicar/100).toFixed(2)} de descuento</span>
                      </label>
                      <input
                        type="range"
                        min={500} max={puntosMaxUsar} step={100}
                        value={puntosAplicar}
                        onChange={e => setPuntosAplicar(parseInt(e.target.value))}
                        className="pp-puntos-range"
                      />
                      <div className="pp-puntos-canje__minmax">
                        <span>500 pts (mín.)</span>
                        <span>{puntosMaxUsar.toLocaleString()} pts (máx. 30%)</span>
                      </div>
                      <div className="pp-puntos-canje__resumen">
                        <span>Total con descuento:</span>
                        <strong>S/. {montoFinal.toFixed(2)}</strong>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {estaLogueado && puntosDisponibles > 0 && puntosDisponibles < 500 && (
                <div className="pp-puntos-insuf">
                  <IconStar/>
                  <div>
                    <strong>Tienes {puntosDisponibles} puntos</strong>
                    <span>Necesitas mínimo 500 para canjear (te faltan {500 - puntosDisponibles})</span>
                  </div>
                </div>
              )}

              {!estaLogueado && (
                <div className="pp-login-hint">
                  <div className="pp-login-hint__icon"><IconStar/></div>
                  <div className="pp-login-hint__texto">
                    <strong>¿Tienes cuenta? Inicia sesión</strong>
                    <span>para usar tus puntos y acumular por esta compra</span>
                  </div>
                  <Link
                    to={`/login?redirect=/pago/${token}`}
                    className="pp-login-hint__btn"
                  >
                    <IconUser/> Iniciar sesión
                  </Link>
                </div>
              )}
            </div>

            {/* ══ MÉTODO DE PAGO ══ */}
            <div className="pp-metodo-selector">
              <p className="pp-comprobante__title">💳 ¿Cómo deseas pagar?</p>

              {!metodoPago && (
                <div className="pp-metodo-btns">
                  <button
                    className="pp-metodo-btn pp-metodo-btn--tarjeta"
                    onClick={() => setMetodoPago('tarjeta')}
                  >
                    <span>💳</span>
                    <div>
                      <strong>Pagar con tarjeta</strong>
                      <span>Visa, Mastercard — acceso inmediato</span>
                    </div>
                  </button>
                  {tieneTransferencia && (
                    <button
                      className="pp-metodo-btn pp-metodo-btn--voucher"
                      onClick={() => setMetodoPago('transferencia')}
                    >
                      <span>🏦</span>
                      <div>
                        <strong>Transferencia bancaria</strong>
                        <span>Subir comprobante — validación en 24h</span>
                      </div>
                    </button>
                  )}
                </div>
              )}

              {/* ── Tarjeta (Culqi) ── */}
              {metodoPago === 'tarjeta' && (
                <div>
                  <button className="pp-metodo-cambiar" onClick={()=>{setMetodoPago(null);setPagoError('');}}>
                    ← Cambiar método
                  </button>

                  {!estaLogueado && (
                    <div style={{display:'flex',flexDirection:'column',gap:'.7rem',marginBottom:'1rem'}}>
                      <div>
                        <label style={{fontSize:'.78rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>
                          Nombre completo *
                        </label>
                        <input
                          type="text" placeholder="Ej: Ana García"
                          value={guestNombre}
                          onChange={e => setGuestNombre(e.target.value)}
                          style={{width:'100%',padding:'.7rem .9rem',borderRadius:10,border:'1.5px solid #e2e8f0',fontFamily:'inherit',fontSize:'.88rem'}}
                        />
                      </div>
                      <div>
                        <label style={{fontSize:'.78rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>
                          Correo electrónico *
                        </label>
                        <input
                          type="email" placeholder="tu@correo.com"
                          value={guestEmail}
                          onChange={e => setGuestEmail(e.target.value)}
                          style={{width:'100%',padding:'.7rem .9rem',borderRadius:10,border:'1.5px solid #e2e8f0',fontFamily:'inherit',fontSize:'.88rem'}}
                        />
                      </div>
                    </div>
                  )}

                  {pagoError && (
                    <div style={{background:'#fff5f5',border:'1px solid #fecaca',borderRadius:8,padding:'.6rem 1rem',fontSize:'.78rem',color:'#c53030',marginBottom:'.8rem'}}>
                      {pagoError}
                    </div>
                  )}

                  <div style={{display:'flex',gap:'.4rem',marginBottom:'1rem',flexWrap:'wrap'}}>
                    {[
                      {icon:'🔒', label:'SSL seguro'},
                      {icon:'✅', label:'Verificado Culqi'},
                      {icon:'🛡️', label:'Sin guardar datos'},
                    ].map(({icon,label})=>(
                      <div key={label} style={{
                        display:'flex', alignItems:'center', gap:'.3rem',
                        background:'#edfaf4', borderRadius:100, padding:'.3rem .75rem',
                        fontSize:'.68rem', fontWeight:700, color:'#4db88a',
                        border:'1px solid rgba(130,216,179,.3)',
                      }}>
                        <span style={{fontSize:'.75rem'}}>{icon}</span>
                        <span>{label}</span>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={pagarConCulqi}
                    disabled={pagando}
                    style={{
                      background: pagando ? '#5a6a63' : '#111614',
                      color:'#82D8B3', fontFamily:"'DM Sans',sans-serif",
                      fontWeight:700, fontSize:'.9rem', letterSpacing:'.05em',
                      textTransform:'uppercase', border:'none', borderRadius:100,
                      padding:'.9rem 2rem', width:'100%', cursor: pagando ? 'not-allowed' : 'pointer',
                      boxShadow:'0 4px 16px rgba(17,22,20,.2)',
                      display:'flex', alignItems:'center', justifyContent:'center', gap:'.5rem',
                    }}
                  >
                    {pagando ? <><IconSpinner/> Procesando…</> : <>💳 Pagar S/. {montoFinal.toFixed(2)}</>}
                  </button>

                  <p style={{textAlign:'center',marginTop:'.7rem',fontSize:'.68rem',color:'#5a6a63'}}>
                    Se abrirá el formulario seguro de Culqi para ingresar tu tarjeta
                  </p>
                </div>
              )}

              {/* ── Transferencia (voucher) ── */}
              {metodoPago === 'transferencia' && (
                <>
                  <button className="pp-metodo-cambiar" onClick={()=>setMetodoPago(null)}>
                    ← Cambiar método
                  </button>

                  <div className="pp-dato-pago">
                    {dp.banco && (
                      <div className="pp-dato-pago__row">
                        <span>Banco</span><strong>{dp.banco}</strong>
                      </div>
                    )}
                    {dp.nombre_cuenta && (
                      <div className="pp-dato-pago__row">
                        <span>Cuenta / CCI</span>
                        <div style={{display:'flex',alignItems:'center',gap:'.5rem'}}>
                          <strong>{dp.nombre_cuenta}</strong>
                          <button className="pp-dato-pago__copy" onClick={()=>copiarCuenta(dp.nombre_cuenta)}>
                            {copied ? '✓' : <IconCopy/>}
                          </button>
                        </div>
                      </div>
                    )}
                    <p className="pp-dato-pago__hint">Monto exacto: <strong>S/. {montoFinal.toFixed(2)}</strong></p>
                  </div>

                  <div className="pp-comprobante">
                    <p className="pp-comprobante__title">📎 Enviar comprobante de pago</p>
                    <p className="pp-comprobante__sub">Sube tu voucher y te activamos el acceso en breve.</p>

                    <div className="pp-campo">
                      <label className="pp-campo__label">
                        N° de operación
                        <span className="pp-campo__opcional">opcional pero recomendado</span>
                      </label>
                      <div className={`pp-campo__input-wrap ${numOpError?'pp-campo__input-wrap--error':''} ${numOpOk&&numOp?'pp-campo__input-wrap--ok':''}`}>
                        <input
                          type="text" placeholder="Ej: 123456789"
                          className="pp-campo__input"
                          value={numOp}
                          onChange={e => { setNumOp(e.target.value); setNumOpError(''); setNumOpOk(false); }}
                          onBlur={() => validarNumOp(numOp)}
                          maxLength={30}
                        />
                        {validandoNum && <span className="pp-campo__spin"><IconSpinner/></span>}
                        {!validandoNum && numOpOk && numOp && <span className="pp-campo__ok">✓</span>}
                      </div>
                      {numOpError && <p className="pp-campo__error">{numOpError}</p>}
                      <p className="pp-campo__hint">Es el código de confirmación que te muestra tu banco.</p>
                    </div>

                    <div className="pp-campo">
                      <label className="pp-campo__label">
                        Comprobante / captura de pago
                        <span className="pp-campo__req">*</span>
                      </label>
                      {!voucher ? (
                        <button type="button" className="pp-upload-zone" onClick={() => fileRef.current?.click()}>
                          <IconImage/>
                          <span className="pp-upload-zone__text">Toca para subir la captura</span>
                          <span className="pp-upload-zone__hint">JPG, PNG, WEBP o PDF · Máx. 10 MB</span>
                        </button>
                      ) : (
                        <div className="pp-voucher-preview">
                          {voucherPrev === 'pdf' ? (
                            <div className="pp-voucher-preview__pdf"><span>📄</span><span>{voucher.name}</span></div>
                          ) : (
                            <img src={voucherPrev} alt="Voucher" className="pp-voucher-preview__img"/>
                          )}
                          <div className="pp-voucher-preview__meta">
                            <span>{voucher.name}</span>
                            <span>{(voucher.size / 1024).toFixed(0)} KB</span>
                          </div>
                          <button className="pp-voucher-preview__cambiar" onClick={quitarVoucher}>
                            <IconTrash/> Cambiar
                          </button>
                        </div>
                      )}
                      <input
                        ref={fileRef} type="file" style={{display:'none'}}
                        accept="image/jpeg,image/png,image/webp,image/gif,application/pdf"
                        onChange={handleVoucherChange}
                      />
                    </div>

                    {envError && <div className="pp-env-error">{envError}</div>}

                    <button
                      className={`pp-btn-enviar ${enviando?'pp-btn-enviar--loading':''}`}
                      onClick={handleEnviar}
                      disabled={enviando || !voucher}
                    >
                      {enviando ? <><IconSpinner/> Enviando…</> : <><IconCheck/> Enviar comprobante</>}
                    </button>

                    <div className="pp-alt-wa">
                      <span>O si prefieres</span>
                      <button className="pp-btn-wa__btn" onClick={abrirWhatsApp}>
                        <IconWhatsapp/> Enviar por WhatsApp
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="pp-seguridad">
              <IconShield/>
              <p>Tus datos están seguros. Solo usamos tu información para procesar el pago y activar el acceso.</p>
            </div>
          </div>

          {!estaLogueado && (
            <div className="pp-hint-cuenta">
              <p>¿Ya tienes cuenta en Comunicar?</p>
              <Link to={`/login?redirect=/pago/${token}`}>Inicia sesión <IconArrow/></Link>
              <span>·</span>
              <Link to="/registro">Créala gratis</Link>
            </div>
          )}

        </div>
      </div>

      <footer className="pp-footer">
        <p>© 2026 Comunicar – Desarrollo y Lenguaje</p>
        <Link to="/">Inicio</Link>
      </footer>

    </div>
  );
}